import React, {useEffect, useState} from "react";
import { useFetch } from "../../../../components/common/FetchProvider";
import { useLocation } from "react-router-dom";
import {columnsDataCashAccountReport} from "../variables/columnsData";
import ColumnsTable from "./ReportTable";
import Loader from "../../../../components/Loader/Loader";
import { formatNumberToInternational } from "../../../../utils/utils";
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;

const BankStatement = () => {
  const fetchWrapper = useFetch();
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState({});
  const [reportData, setReportData] = useState([]);
  const [footerData, setFooterData] = useState({});

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract query parameters
  const accountId = queryParams.get("accountId");
  const yearMonth = queryParams.get("yearMonth");

  useEffect(() => {
    fetchbankReport(accountId, yearMonth);
  }, []);

  useEffect(() => {
    if (reportData) {
      let pageBalance = reportData.map((page) => ({
        expenseEuro: formatNumberToInternational(page.pageTotalCredit),
        incomeEuro: formatNumberToInternational(page.pageTotalDebit),
        balance: formatNumberToInternational(page.totalBalance),
        incomeKwanza: formatNumberToInternational(page.pageTotalDebitAkz),
        expenseKwanza: formatNumberToInternational(page.pageTotalCreditAkz),
      }));
      setFooterData(pageBalance);
    }
  }, [reportData]);

  const fetchbankReport = async (accountId, yearMonth) => {
    setLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/v1/reports/bank-account?accountId=${accountId}&yearMonth=${yearMonth}`;
      const userToken = localStorage.getItem("token");
      const response = await fetchWrapper(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoading(false);
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data) {
          setApiData(responseData.data);
          setReportData(responseData.data.bankReportsPages);
        }
      } else {
        console.error('Error fetching API data:', response.status);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching API data:', error);
    }
  }

  const mapApiData = (reportData) => {
    let combinedData = [];
  
    // Separate credit and debit entries and ensure both sides are populated
    let creditEntries = reportData.filter(report => report.credit && report.credit > 0);
    let debitEntries = reportData.filter(report => report.debit && report.debit > 0);
  
    // Calculate the maximum length to decide how many rows to display
    const maxLength = Math.max(creditEntries.length, debitEntries.length);
  
    // Create a new array with credit and debit entries in the same row
    for (let i = 0; i < maxLength; i++) {
      combinedData.push({
        expenseDia: creditEntries[i] ? creditEntries[i].dia : '', // Handle missing credit data
        expenseNDoc: creditEntries[i] ? creditEntries[i].seqNumber : '',
        expenseDescription: creditEntries[i] ? creditEntries[i].description : '',
        expenseEuro: creditEntries[i] ? formatNumberToInternational(creditEntries[i].credit) : '',
        expenseKwanza: creditEntries[i] ? formatNumberToInternational(creditEntries[i].kwanza) : '',
  
        incomeDia: debitEntries[i] ? debitEntries[i].dia : '', // Handle missing debit data
        incomeNDoc: debitEntries[i] ? debitEntries[i].seqNumber : '',
        incomeDescription: debitEntries[i] ? debitEntries[i].description : '',
        incomeEuro: debitEntries[i] ? formatNumberToInternational(debitEntries[i].debit) : '',
        incomeKwanza: debitEntries[i] ? formatNumberToInternational(debitEntries[i].kwanza) : '',

      });
    }
  
    return combinedData;
  };
  



  const handlePrint = () => {
    window.print();
  };

  return (
   <div className="p-2">
     <Loader show={loading}/>
     {
         reportData && reportData.map((report) => {
           return <div className="max-w-7xl mx-auto">
             {/* Header */}
             <div className="flex justify-between items-center mb-4 text-black dark:text-white">
               <div className="flex-1 text-center">
               <div className="flex items-center justify-center h-[100px]">
  <img
    src={logo}
    alt="Logo"
    className="w-[60px] h-[80px] object-contain"
  />
</div>
                 <h1 className="text-xl font-bold">REPÚBLICA DE ANGOLA</h1>
                 <h2 className="text-md">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
                 <h2 className="text-md">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
                 <h2 className="text-md font-bold">CONTA CORRENTE COM CAIXA</h2>
                 <h2 className="text-md">MÊS DE {apiData.monthNameAndYear}</h2>
               </div>

               <div className="text-right">
                 <p className="text-md">Fls: {report.pageNumber}</p>
                 <p className="text-md text-red-600">UNIDADE MONETÁRIA: {apiData.accountCurrency}</p>
                 <p className="text-md text-red-600">Câmbio {apiData.exchangeRate}</p>
               </div>
             </div>

             {/* Print Button */}
             {
                 report.pageNumber === 1 && (
                     <div className="text-right mb-4">
                       <button
                           onClick={handlePrint}
                           className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
                         Print
                       </button>
                     </div>
                 )
             }

             {/* Table */}


             <div className="text-right mb-4">
               {report && footerData.length > 0 && report.pageNumber <= footerData.length && (
                   <ColumnsTable
                       columnsData={columnsDataCashAccountReport}
                       tableData={mapApiData(report.bankReports)}
                       footerData={footerData[report.pageNumber - 1]}
                   />
               )}
             </div>

             {/* Footer */}
             <div className="flex justify-between mt-4">
               <div>
               <p className="text-red-600 text-center">O ADIDO FINANCEIRO</p>
                 <hr className="border-t-2 border-black my-4"/>
                 <p className="font-bold">{FINANCIAL_HEAD}</p>

               </div>
               <div>
                 <p className="text-red-600 text-center">EMBAIXADORA</p>
                 <hr className="border-t-2 border-black my-4"/>
                 <p className="font-bold">{EMBAIXADOR}</p>
               </div>
               <div>
                 <p>Saldo p/Mes Segu: {formatNumberToInternational(apiData.nextMonthBalance)}</p>
               </div>
             </div>
           </div>
         })
     }

   </div>
  );
};

export default BankStatement;